<template>
    <div class="vh-100">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtolistpotongansx">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Denda</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>
        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="m-t-16 m-d-16 p-x-20 w-limit">
                <div class="d-flex justify-content-between">
                    <div class="f-16 f-semi">{{namakaryawan_potonganx}}</div>

                    <!--
                    ## statuses class
                    .badge.color-red = belum lunas
                    .badge.color-yellow = cicilan
                    .badge.color green = lunas
                    -->
                    <div class="badge color-green">Lunas</div>
                </div>
                <div class="m-d-16">
                    <div class="f-13  f-c-midgrey" v-if="this.statusoutletx==='true'"><b>Kasir</b> {{namaoutletx}}</div>
                    <div class="f-13  f-c-midgrey" v-if="this.statusworkshopx==='true'"><b>Workshop</b> {{namaworkshopx}}</div>
                    <div class="f-13  f-c-midgrey" v-if="this.statuskurirx==='true'" id="statuskurirx"><b>Kurir</b></div>
                </div>
            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16">
                <div id="tgl-kasbon" class="d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Tgl Detail</div>
                    <div class="f-16">{{date_lunas_potonganx}}</div>
                </div>
                <div id="tgl-lunas" class="m-t-8 d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Tgl Lunas</div>
                    <div class="f-16">{{waktu_pembayaraan}}</div>
                </div>

                <div class="separator-line-dot m-x-min m-t-16 m-d-16" v-if="statusriwayatbayar===1"></div>

                <div id="total-kasbon" class="m-t-8 d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Total Denda</div>
                    <div class="f-16 f-semi">{{saldo_potonganx | currency}}</div>
                </div>
                <div class="m-t-8" v-if="statusriwayatbayar===1">
                    <div class="f-c-blue f-14 f-semi m-r-4" @click="riwayatcicil(dataidpotonganx.idpotonganx)">
                      Riwayat Cicilan
                      <img src="../../../assets/icons/chevron-right1.svg" height="14px" alt="">
                    </div>
                </div>
            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16">
                <div class="f-16 f-c-midgrey">Keterangan</div>
                <div class="f-16">{{keterangankaryawan_potonganx}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailPotonganx",
        props:['dataidpotonganx'],
        data(){
            return{
                detailpotonganx:{},
                namakaryawan_potonganx:'',
                keterangankaryawan_potonganx:'',
                saldo_potonganx:'',
                date_lunas_potonganx:'',
                waktu_pembayaraan:'',
                namaworkshopx:'',
                namaoutletx:'',
                statusoutletx:'',
                statusworkshopx:'',
                statuskurirx:'',
                statusriwayatbayar:0,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.getDetailpotongansx()

			this.backButtonPressed(this.backtolistpotongansx)
        },
        methods:{
            riwayatcicil(id){
                this.$emit('riwayatpotongan',{id: id, islunas: 1})
            },
            backtolistpotongansx(){
              this.$emit('backtolistpotx')
            },
            async getDetailpotongansx() {
                this.namaworkshopx = '';
                this.namaoutletx='';
                this.statusoutletx='false';
                this.statusworkshopx='false';
                this.statuskurirx='false';
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/detail_potongan?idpotongan=' + this.dataidpotonganx.idpotonganx,this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            var detailpotonganx = response.data.data.detail;
                            var data = response.data.data;
                            var lenght_potbay = detailpotonganx.potongan_bayar.length;
                            this.namakaryawan_potonganx = detailpotonganx.karyawan.nama;
                            this.keterangankaryawan_potonganx = detailpotonganx.keterangan;
                            this.saldo_potonganx = detailpotonganx.nominal;
                            this.date_lunas_potonganx = data.waktu_potongan;
                            this.waktu_pembayaraan = data.waktu_pembayaran_terakhir;
                            if(lenght_potbay>1){
                                this.statusriwayatbayar = 1;
                            }
                            if (detailpotonganx.karyawan.daftar_karyawan_outlet != null) {
                                this.namaoutletx = detailpotonganx.karyawan.daftar_karyawan_outlet.outlet.nama;
                                this.statusoutletx = "true";

                            }
                            if (detailpotonganx.karyawan.daftar_karyawan_workshop != null) {
                                this.namaworkshopx = detailpotonganx.karyawan.daftar_karyawan_workshop.workshop.nama;
                                this.statusworkshopx = "true";
                            }

                            if (detailpotonganx.karyawan.daftar_karyawan_kurir != null) {
                                this.statuskurirx = "true";
                            }

                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },
        }
    }
</script>

<style scoped>

</style>